import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Modal, Popover, QRCode, Table, Tooltip } from "antd";
import axios from "axios";
// import {
//   CustomerOrderInfo,
//   NotificationInfo,
//   SubscriptionInfo,
//   UserInfo,
// } from "../../../context";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ExpandAltOutlined,
  ScheduleOutlined,
  QrcodeOutlined,
  SyncOutlined,
} from "@ant-design/icons";
// import MerchantOrdersDetails from "./MerchantOrdersDetails";
// import MerchantLayout from "../../layout/MerchantLayout";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { NotificationInfo, UserInfo } from "../../../../../context";
// import LOGO from "./../../../../../assets/logo.png";
import MerchantEmployeeEditBooking from "./MerchantEmployeeEditBooking";
// import MerchantEditBooking from "./MerchantEditBooking";
// import MerchantExtendService from "./MerchantExtendService";
// import MerchantCheckoutService from "./MerchantCheckoutService";
// import MerchantCreateCustomer from "./MerchantCreateCustomer";

const MerchantEmployeeBooking = ({
  bookingList,
  activeServiceList,
  rerun,
  refresh,
  loading,
}) => {
  const [search, setSearch] = useState("");
  const tableLayout = "";
  const scroll = {};
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openExtendDrawer, setOpenExtendDrawer] = useState(false);
  const [openCheckoutDrawer, setOpenCheckoutDrawer] = useState(false);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  //   const [loading, setLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [selectedBookService, setSelectedBookService] = useState(null);

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "started_date",
      render: (text, record) => (
        <p>
          {moment(`${text.replace(" ", "T")}.000000Z`)
            .utc()
            .format("LLL")}
        </p>
      ),
    },
    {
      title: "Transaction #",
      dataIndex: "transaction_id",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Category",
      // dataIndex: "table_no",
      render: (text, record) => (
        <p>
          {text.booked_category == "booking" ? "Booking" : "Pencil Booking"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 150,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 150 }}>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                const specificData = activeServiceList.data.filter(
                  (res) =>
                    res.service === text.product &&
                    res.service_type === text.service_type
                );
                // console.log("text: ", text);
                // console.log("specificData: ", specificData);
                // console.log("activeServiceList: ", activeServiceList);
                setSelectedBookService(specificData[0]);
                setSelectedData(text);
                setOpenEditDrawer(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 5 }}
              size="small"
            />
          </Tooltip>

          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const searchable = bookingList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteCustomerService();
    }, 2000);
  };

  const handleDeleteCustomerService = () => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    axios
      .post("user/merchant/delete-avail-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete service successfully.");
          setTimeout(() => {
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search-reserve"
              placeholder="Search transaction # or name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button type="default" icon={<SyncOutlined />} onClick={refresh}>
            Refresh
          </Button>
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        />
      </div>

      {openEditDrawer && (
        <MerchantEmployeeEditBooking
          open={openEditDrawer}
          close={() => setOpenEditDrawer(false)}
          activeServiceList={activeServiceList}
          getMerchantOrderSaveList={() => rerun()}
          selectedData={selectedData}
          selectedBookService={
            selectedBookService !== null && selectedBookService
          }
          setSelectedBookService={setSelectedBookService}
        />
      )}

      <Modal
        title="Delete this transaction?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />
    </>
  );
};

export default MerchantEmployeeBooking;
